// src/PageHeader.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import styles from './PageHeader.module.css';

export default function PageHeader({ title, subtitle }) {
  return (
    <header className={styles.header}>
      <nav className={styles.navbar}>
        <Link to="/" className={styles.logo}>
          Kigaa Self-Help Water Society
        </Link>
        <Link to="/" className={styles.backLink}>
          Back to Home
        </Link>
      </nav>

      <div className={styles.hero}>
        <h1 className={styles.title}>{title}</h1>
        {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
      </div>
    </header>
  );
}